import _toConsumableArray from "/trueskin-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/trueskin-web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/trueskin-web/node_modules/@babel/runtime/helpers/esm/createClass.js";
// uncomment for packing
// import "../styles/index.scss";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
var ImageCompare = /*#__PURE__*/function () {
  function ImageCompare(el) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, ImageCompare);
    var defaults = {
      controlColor: "#FFFFFF",
      controlShadow: true,
      addCircle: false,
      addCircleBlur: true,
      showLabels: false,
      labelOptions: {
        before: "Before",
        after: "After",
        onHover: false
      },
      smoothing: true,
      smoothingAmount: 100,
      hoverStart: false,
      verticalMode: false,
      startingPoint: 50,
      fluidMode: false
    };
    this.settings = Object.assign(defaults, settings);
    this.safariAgent = navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1;
    this.el = el;
    this.images = {};
    this.wrapper = null;
    this.control = null;
    this.arrowContainer = null;
    this.arrowAnimator = [];
    this.active = false;
    this.slideWidth = 50;
    this.lineWidth = 2;
    this.arrowCoordinates = {
      circle: [5, 3],
      standard: [8, 0]
    };
  }
  _createClass(ImageCompare, [{
    key: "mount",
    value: function mount() {
      // Temporarily disable Safari smoothing
      if (this.safariAgent) {
        this.settings.smoothing = false;
      }
      this._shapeContainer();
      this._getImages();
      this._buildControl();
      this._events();
    }
  }, {
    key: "_events",
    value: function _events() {
      var _this = this;
      var bodyStyles = "\n\n    ";

      // Desktop events
      this.el.addEventListener("mousedown", function (ev) {
        _this._activate(true);
        document.body.classList.add("icv__body");
        disableBodyScroll(_this.el, {
          reserveScrollBarGap: true
        });
        _this._slideCompare(ev);
      });
      this.el.addEventListener("mousemove", function (ev) {
        return _this.active && _this._slideCompare(ev);
      });
      this.el.addEventListener("mouseup", function () {
        return _this._activate(false);
      });
      document.body.addEventListener("mouseup", function () {
        document.body.classList.remove("icv__body");
        enableBodyScroll(_this.el);
        _this._activate(false);
      });

      // Mobile events

      this.control.addEventListener("touchstart", function (e) {
        _this._activate(true);
        document.body.classList.add("icv__body");
        disableBodyScroll(_this.el, {
          reserveScrollBarGap: true
        });
      });
      this.el.addEventListener("touchmove", function (ev) {
        _this.active && _this._slideCompare(ev);
      });
      this.el.addEventListener("touchend", function () {
        _this._activate(false);
        document.body.classList.remove("icv__body");
        enableBodyScroll(_this.el);
      });

      // hover

      this.el.addEventListener("mouseenter", function () {
        _this.settings.hoverStart && _this._activate(true);
        var coord = _this.settings.addCircle ? _this.arrowCoordinates.circle : _this.arrowCoordinates.standard;
        _this.arrowAnimator.forEach(function (anim, i) {
          anim.style.cssText = "\n        ".concat(_this.settings.verticalMode ? "transform: translateY(".concat(coord[1] * (i === 0 ? 1 : -1), "px);") : "transform: translateX(".concat(coord[1] * (i === 0 ? 1 : -1), "px);"), "\n        ");
        });
      });
      this.el.addEventListener("mouseleave", function () {
        var coord = _this.settings.addCircle ? _this.arrowCoordinates.circle : _this.arrowCoordinates.standard;
        _this.arrowAnimator.forEach(function (anim, i) {
          anim.style.cssText = "\n        ".concat(_this.settings.verticalMode ? "transform: translateY(".concat(i === 0 ? "".concat(coord[0], "px") : "-".concat(coord[0], "px"), ");") : "transform: translateX(".concat(i === 0 ? "".concat(coord[0], "px") : "-".concat(coord[0], "px"), ");"), "\n        ");
        });
      });
    }
  }, {
    key: "_slideCompare",
    value: function _slideCompare(ev) {
      var bounds = this.el.getBoundingClientRect();
      var x = ev.touches !== undefined ? ev.touches[0].clientX - bounds.left : ev.clientX - bounds.left;
      var y = ev.touches !== undefined ? ev.touches[0].clientY - bounds.top : ev.clientY - bounds.top;
      var position = this.settings.verticalMode ? y / bounds.height * 100 : x / bounds.width * 100;
      if (position >= 0 && position <= 100) {
        this.settings.verticalMode ? this.control.style.top = "calc(".concat(position, "% - ").concat(this.slideWidth / 2, "px)") : this.control.style.left = "calc(".concat(position, "% - ").concat(this.slideWidth / 2, "px)");
        if (this.settings.fluidMode) {
          this.settings.verticalMode ? this.wrapper.style.clipPath = "inset(0 0 ".concat(100 - position, "% 0)") : this.wrapper.style.clipPath = "inset(0 0 0 ".concat(position, "%)");
        } else {
          this.settings.verticalMode ? this.wrapper.style.height = "calc(".concat(position, "%)") : this.wrapper.style.width = "calc(".concat(100 - position, "%)");
        }
      }
    }
  }, {
    key: "_activate",
    value: function _activate(state) {
      this.active = state;
    }
  }, {
    key: "_shapeContainer",
    value: function _shapeContainer() {
      var imposter = document.createElement("div");
      var label_l = document.createElement("span");
      var label_r = document.createElement("span");
      label_l.classList.add("icv__label", "icv__label-before", "keep");
      label_r.classList.add("icv__label", "icv__label-after", "keep");
      if (this.settings.labelOptions.onHover) {
        label_l.classList.add("on-hover");
        label_r.classList.add("on-hover");
      }
      if (this.settings.verticalMode) {
        label_l.classList.add("vertical");
        label_r.classList.add("vertical");
      }
      label_l.innerHTML = this.settings.labelOptions.before || "Before";
      label_r.innerHTML = this.settings.labelOptions.after || "After";
      if (this.settings.showLabels) {
        this.el.appendChild(label_l);
        this.el.appendChild(label_r);
      }
      this.el.classList.add("icv", this.settings.verticalMode ? "icv__icv--vertical" : "icv__icv--horizontal", this.settings.fluidMode ? "icv__is--fluid" : "standard");
      imposter.classList.add("icv__imposter");
      this.el.appendChild(imposter);
    }
  }, {
    key: "_buildControl",
    value: function _buildControl() {
      var _this2 = this;
      var control = document.createElement("div");
      var uiLine = document.createElement("div");
      var arrows = document.createElement("div");
      var circle = document.createElement("div");
      var arrowSize = "20";
      arrows.classList.add("icv__theme-wrapper");
      for (var idx = 0; idx <= 1; idx++) {
        var animator = document.createElement("div");
        var arrow = "<svg\n      height=\"15\"\n      width=\"15\"\n       style=\"\n       transform: \n       scale(".concat(this.settings.addCircle ? 0.7 : 1.5, ")  \n       rotateZ(").concat(idx === 0 ? this.settings.verticalMode ? "-90deg" : "180deg" : this.settings.verticalMode ? "90deg" : "0deg", "); height: ").concat(arrowSize, "px; width: ").concat(arrowSize, "px;\n       \n       ").concat(this.settings.controlShadow ? "\n       -webkit-filter: drop-shadow( 0px 3px 5px rgba(0, 0, 0, .33));\n       filter: drop-shadow( 0px ".concat(idx === 0 ? "-3px" : "3px", " 5px rgba(0, 0, 0, .33));\n       ") : "", "\n       \"\n       xmlns=\"http://www.w3.org/2000/svg\" data-name=\"Layer 1\" viewBox=\"0 0 15 15\">\n       <path ").concat(this.settings.addCircle ? "fill=\"transparent\"" : "fill=\"".concat(this.settings.controlColor, "\""), "\n       stroke=\"").concat(this.settings.controlColor, "\"\n       stroke-linecap=\"round\"\n       stroke-width=\"").concat(this.settings.addCircle ? 3 : 0, "\"\n       d=\"M4.5 1.9L10 7.65l-5.5 5.4\"\n       />\n     </svg>");
        animator.innerHTML += arrow;
        this.arrowAnimator.push(animator);
        arrows.appendChild(animator);
      }
      var coord = this.settings.addCircle ? this.arrowCoordinates.circle : this.arrowCoordinates.standard;
      this.arrowAnimator.forEach(function (anim, i) {
        anim.classList.add("icv__arrow-wrapper");
        anim.style.cssText = "\n      ".concat(_this2.settings.verticalMode ? "transform: translateY(".concat(i === 0 ? "".concat(coord[0], "px") : "-".concat(coord[0], "px"), ");") : "transform: translateX(".concat(i === 0 ? "".concat(coord[0], "px") : "-".concat(coord[0], "px"), ");"), "\n      ");
      });
      control.classList.add("icv__control");
      control.style.cssText = "\n    ".concat(this.settings.verticalMode ? "height" : "width ", ": ").concat(this.slideWidth, "px;\n    ").concat(this.settings.verticalMode ? "top" : "left ", ": calc(").concat(this.settings.startingPoint, "% - ").concat(this.slideWidth / 2, "px);\n    ").concat("ontouchstart" in document.documentElement ? "" : this.settings.smoothing ? "transition: ".concat(this.settings.smoothingAmount, "ms ease-out;") : "", "\n    ");
      uiLine.classList.add("icv__control-line");
      uiLine.style.cssText = "\n      ".concat(this.settings.verticalMode ? "height" : "width ", ": ").concat(this.lineWidth, "px;\n      background: ").concat(this.settings.controlColor, ";\n        ").concat(this.settings.controlShadow ? "box-shadow: 0px 0px 15px rgba(0,0,0,0.33);" : "", "\n    ");
      var uiLine2 = uiLine.cloneNode(true);
      circle.classList.add("icv__circle");
      circle.style.cssText = "\n\n      ".concat(this.settings.addCircleBlur && "-webkit-backdrop-filter: blur(5px); backdrop-filter: blur(5px)", ";\n      \n      border: ").concat(this.lineWidth, "px solid ").concat(this.settings.controlColor, ";\n      ").concat(this.settings.controlShadow && "box-shadow: 0px 0px 15px rgba(0,0,0,0.33)", ";\n    ");
      control.appendChild(uiLine);
      this.settings.addCircle && control.appendChild(circle);
      control.appendChild(arrows);
      control.appendChild(uiLine2);
      this.arrowContainer = arrows;
      this.control = control;
      this.el.appendChild(control);
    }
  }, {
    key: "_getImages",
    value: function _getImages() {
      var _this3 = this;
      var children = this.el.querySelectorAll("img, .keep");
      this.el.innerHTML = "";
      children.forEach(function (img) {
        _this3.el.appendChild(img);
      });
      var childrenImages = _toConsumableArray(children).filter(function (element) {
        return element.nodeName.toLowerCase() === "img";
      });

      //  this.settings.verticalMode && [...children].reverse();
      this.settings.verticalMode && childrenImages.reverse();
      for (var idx = 0; idx <= 1; idx++) {
        var child = childrenImages[idx];
        child.classList.add("icv__img");
        child.classList.add(idx === 0 ? "icv__img-a" : "icv__img-b");
        if (idx === 1) {
          var wrapper = document.createElement("div");
          var afterUrl = childrenImages[1].src;
          wrapper.classList.add("icv__wrapper");
          wrapper.style.cssText = "\n            width: ".concat(100 - this.settings.startingPoint, "%; \n            height: ").concat(this.settings.startingPoint, "%;\n\n            ").concat("ontouchstart" in document.documentElement ? "" : this.settings.smoothing ? "transition: ".concat(this.settings.smoothingAmount, "ms ease-out;") : "", "\n            ").concat(this.settings.fluidMode && "background-image: url(".concat(afterUrl, "); clip-path: inset(").concat(this.settings.verticalMode ? " 0 0 ".concat(100 - this.settings.startingPoint, "% 0") : "0 0 0 ".concat(this.settings.startingPoint, "%"), ")"), "\n        ");
          wrapper.appendChild(child);
          this.wrapper = wrapper;
          this.el.appendChild(this.wrapper);
        }
      }
      if (this.settings.fluidMode) {
        var url = childrenImages[0].src;
        var fluidWrapper = document.createElement("div");
        fluidWrapper.classList.add("icv__fluidwrapper");
        fluidWrapper.style.cssText = "\n \n        background-image: url(".concat(url, ");\n        \n      ");
        this.el.appendChild(fluidWrapper);
      }
    }
  }]);
  return ImageCompare;
}(); // const el = document.querySelectorAll(".image-compare");
// el.forEach((viewer) => {
//   let v = new ImageCompare(viewer, {
//     controlShadow: false,
//     showLabels: true,
//     labelOptions: {
//       onHover: true,
//       before: "Draft",
//       after: "Final",
//     },
//   }).mount();
// });
export default ImageCompare;